if (!customElements.get('mfc-product-carousel')) {
  customElements.define('mfc-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        const grid = this.querySelector('[data-recent-grid]');
        const arrows = this.querySelector('[data-recent-arrows]');
        if (!grid || !arrows) return;
        const update = () => {
          const max = grid.scrollWidth - grid.clientWidth;
          arrows.hidden = max < 2;
          const buttons = arrows.querySelectorAll('button');
          buttons[0].disabled = grid.scrollLeft < 2;
          buttons[1].disabled = grid.scrollLeft >= max - 2;
          const media = grid.querySelector('.card__inner');
          const header = this.querySelector('.mfvp-recent-header');
          const page = this.querySelector('.page-width');
          if (media && header && page) {
            this.style.setProperty('--mfvp-recent-arrow-top', `${header.offsetHeight + parseFloat(getComputedStyle(header).marginBottom) + media.getBoundingClientRect().height / 2}px`);
            this.style.setProperty('--mfvp-recent-inset', getComputedStyle(page).paddingLeft);
          }
        };
        arrows.addEventListener('click', event => {
          const button = event.target.closest('[data-recent-step]');
          if (!button || button.disabled) return;
          grid.scrollBy({left: Number(button.dataset.recentStep) * grid.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal: this.abort.signal});
        grid.addEventListener('scroll', update, {passive: true, signal: this.abort.signal});
        this.resize = new ResizeObserver(update);
        this.resize.observe(grid);
        update();
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}
